import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';

export type DialogContentProps = {
  children: React.ReactNode | React.ReactElement;
};

export type DialogContainerProps = {
  children: React.ReactNode | React.ReactElement;
  open: boolean;
  disabled: boolean;
  title: string;
  allowBackdropClick?: boolean;
  contextTitle?: string;
  loading?: boolean;
  onClose: (value: boolean) => void;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  onSubmitAsync?: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
};

export const DialogHeader = (props: DialogContentProps) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export const DialogBody = (props: DialogContainerProps) => {
  const {
    open,
    title,
    disabled = false,
    allowBackdropClick = true,
    loading = false,
    contextTitle = '',
    onClose,
    onSubmit,
    onSubmitAsync,
    children,
  } = props;

  const handleDialogClose = (
    event: React.FormEvent<HTMLFormElement>,
    reason: string
  ): void => {
    if (allowBackdropClick && reason !== 'backdropClick') {
      handleButtonClick();
    }
  };

  const handleButtonClick = () => {
    onClose(false);
  };
  return (
    <React.Fragment>
      <Dialog
        disableEscapeKeyDown
        disableRestoreFocus
        open={open}
        onClose={handleDialogClose}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <form onSubmit={onSubmit ? onSubmit : onSubmitAsync}>
          {title && <DialogTitle>{title}</DialogTitle>}
          <DialogContent>
            {contextTitle && (
              <DialogContentText>{contextTitle}</DialogContentText>
            )}
            {children}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleButtonClick}>Cancel</Button>
            {loading ? (
              <div>
                <CircularProgress />
              </div>
            ) : (
              <Button type="submit" variant="contained" disabled={disabled}>
                Save
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

const FormDialogContainer = (props: DialogContentProps) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default FormDialogContainer;
